import Section from '../Section';
import KenBurns from '../global/KenBurns';

export default class Hero extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);

    document.querySelectorAll('.homepage-hero-menu li').forEach(link => {
      this.hoverEffect(link);
    });
  }

  hoverEffect = (link) => {
    const overlayId = link.getAttribute('data-overlay-id');
    const overlay = document.getElementById(overlayId);

    if (!overlay) return;

    link.addEventListener('mouseenter', () => {
      overlay.classList.add("active");
    });

    link.addEventListener('mouseleave', () => {
      overlay.classList.remove("active");
    });

    // Apply hover on page load
    if (link.matches(':hover')) {
      overlay.classList.add("active");
    }
  }
}
